'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');

const VARIANTS = [
    {
        name: 'title1',
        class: 'typo-title1'
    },
    {
        name: 'title2',
        class: 'typo-title2'
    },
    {
        name: 'title3',
        class: 'typo-title3'
    },
    {
        name: 'subTitle1',
        class: 'typo-subTitle1'
    },
    {
        name: 'subTitle2',
        class: 'typo-subTitle2'
    },
    {
        name: 'contents1',
        class: 'typo-contents1'
    },
    {
        name: 'contents2',
        class: 'typo-contents2'
    },
    {
        name: 'body1',
        class: 'typo-body1'
    },
    {
        name: 'body2',
        class: 'typo-body2'
    },
    {
        name: 'body3',
        class: 'typo-body3'
    },
    {
        name: 'caption1',
        class: 'typo-caption1'
    },
    {
        name: 'caption2',
        class: 'typo-caption2'
    }
];
/**
 * Typography
 * @param {Object} props
 * @param {React.ReactNode} props.children - Typography 내부에 들어갈 컨텐츠
 * @param {string} props.variant - 텍스트 스타일 variant ('title1' | 'title2' | 'title3' | 'subTitle1' | 'subTitle2' | 'contents1' | 'contents2' | 'body1' | 'body2' | 'body3' | 'caption1' | 'caption2')
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {keyof JSX.IntrinsicElements} [props.as='span'] - 렌더링할 HTML 요소
 */ const Typography = (_a)=>{
    var _b;
    var { children, variant, className, as = 'span' } = _a, rest = _tslib.__rest(_a, [
        "children",
        "variant",
        "className",
        "as"
    ]);
    const Component = as || 'span';
    const matchedVariantClass = ((_b = VARIANTS.find((eachVariant)=>eachVariant.name === variant)) === null || _b === void 0 ? void 0 : _b.class) || '';
    return jsxRuntime.jsx(Component, Object.assign({
        className: tailwindMerge.twMerge('tracking-default', matchedVariantClass, className)
    }, rest, {
        children: children
    }));
};

module.exports = Typography;
